import { CommentableType } from "../models/comment"

export default class CommentForm {
  public body: string = ''
  public commentableId: number
  public commentableType: CommentableType
}
